import React from 'react'

// A single KPI tile (value + label) used by OverviewSummary.
const StatCard = ({ value, label }) => {
    return (
        <div className='border border-[#e9e9ea] bg-white p-5 min-h-[128px] flex flex-col justify-between'>
            <h3 className='text-[28px] leading-9 font-bold text-[#21242b]'>
                {value}
            </h3>
            <p className='regular-12 text-[#6a6c71] mt-2'>{label}</p>
        </div>
    )
}

export default StatCard
